﻿window.VoterFly.Stripe = {
    initializeCheckout: function (perishableKey, params, beforeSubmit) {
        if (typeof fbq !== 'undefined') { fbq('track', 'InitiateCheckout'); }

        VoterFly.UI.showLoader();

        // We don't want to overwrite the passed in params
        var newParams = Object.assign({}, params || {});

        // Allow the app to suppliment params
        if (beforeSubmit) {
            beforeSubmit(newParams);
        }

        return $.ajax({
            url: '/api/stripe/InitializeOrder',
            type: 'POST',
            data: JSON.stringify(newParams),
            async: true,
            cache: false,
            contentType: "application/json",
            processData: false
        }).then(function (data) {
            const stripe = Stripe(perishableKey);
            stripe.redirectToCheckout({
                sessionId: data.id
            })
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `error.message`.
        });
    },

    enhanceElements: function ($elements, perishableKey, params, beforeSubmit) {
        if ($elements.length == 0) {
            return;
        }

        $this = this;

        $elements.each(function (idx, elem) {

            $(elem).click((evt) => {
                evt.preventDefault();

                // We don't want to overwrite the passed in params
                var newParams = Object.assign({}, params || {});

                // Great idea... not used.
                var successUrl = $(elem).data('success-url');
                if (successUrl) {
                    newParams['successUrl'] = successUrl;
                }

                var cancelUrl = $(elem).data('cancel-url');
                if (cancelUrl) {
                    newParams['cancelUrl'] = cancelUrl;
                }


                $this.initializeCheckout(perishableKey, newParams, beforeSubmit);
            });
        });
    }
};
